import moment from 'moment-timezone';
import StatusHelper from '@wix/wixrest-utils/dist/openrest-helpers/Status';
import { getAllInBounds, getMinimalOrderPriceForAllAreas, } from './addressLogic';
import _ from 'lodash';
function getDisplayablePrice(price, locale, currency) {
    if (price === void 0) { price = 0; }
    var formattedLocale = locale.replace('_', '-');
    var numberFormat = new Intl.NumberFormat(formattedLocale, {
        style: 'currency',
        currency: currency,
    });
    return numberFormat.format(price / 100);
}
export function getDefaultDispatchType(_a) {
    var restaurant = _a.restaurant, dispatchTime = _a.dispatchTime, displayableMenu = _a.displayableMenu, shouldUseDefaultDispatchType = _a.shouldUseDefaultDispatchType;
    var dispatchTypes = restaurant.deliveryInfos
        .filter(function (di) {
        return isDispatchInfoActive(di, moment(dispatchTime).tz(restaurant.timezone));
    })
        .map(function (di) { return di.type; });
    var uniqueDispatchTypes = Array.from(new Set(dispatchTypes));
    var foundDeliverableItems = hasAnyDeliverableItems(displayableMenu);
    var isDeliverySupported = foundDeliverableItems && uniqueDispatchTypes.includes('delivery');
    var customDefaultDispatchType = restaurant.defaultDispatchType || 'delivery';
    if (uniqueDispatchTypes.length === 0) {
        throw new Error('getDefaultDispatchType: No dispatch type found');
    }
    else if (uniqueDispatchTypes.length === 1) {
        return uniqueDispatchTypes[0];
    }
    else if (shouldUseDefaultDispatchType) {
        if (customDefaultDispatchType === 'delivery') {
            return isDeliverySupported ? customDefaultDispatchType : 'takeout';
        }
        else {
            return customDefaultDispatchType;
        }
    }
    else {
        return isDeliverySupported ? 'delivery' : 'takeout';
    }
}
export function hasAnyDeliverableItems(displayableMenu) {
    return displayableMenu
        .map(function (_menu) {
        return _menu.sections.map(function (section) { return section.items.length > 0; }).some(Boolean);
    })
        .some(Boolean);
}
function isDispatchInfoActive(dispatchInfo, dispatchTime) {
    var _a = StatusHelper.getStatus(dispatchInfo.availability, dispatchTime), status = _a.status, reason = _a.reason;
    var isClosed = status === 'unavailable' && reason === 'closed';
    return dispatchInfo.inactive !== true && !isClosed;
}
export function isMinimumPriceMet(_a) {
    var totalOrderPrice = _a.totalOrderPrice, restaurant = _a.restaurant, dispatchType = _a.dispatchType, selectedAddressOption = _a.selectedAddressOption, dispatchTime = _a.dispatchTime, options = _a.options;
    var minOrderPrice = getMinOrderPrice({
        totalOrderPrice: totalOrderPrice,
        restaurant: restaurant,
        dispatchType: dispatchType,
        selectedAddressOption: selectedAddressOption,
        dispatchTime: dispatchTime,
        options: options,
    });
    return totalOrderPrice >= minOrderPrice;
}
export function getMinimalPickupOrderPrice(deliveryInfos) {
    var takeout = deliveryInfos.find(function (di) { return di.type === 'takeout'; });
    var minOrderPrice = (takeout === null || takeout === void 0 ? void 0 : takeout.minOrderPrice) || 0;
    return minOrderPrice;
}
/**
 * @returns Returns the minumum order price for the ideal delivery area
 *
 * If we have met the minimum order price in one or more delivery areas we pick the one with the smallest delivery fee.
 * Else we will return the lowest minimum price in all delivery areas that can deliver to the address
 */
export function getMinOrderPrice(_a) {
    var _b;
    var totalOrderPrice = _a.totalOrderPrice, restaurant = _a.restaurant, dispatchType = _a.dispatchType, dispatchTime = _a.dispatchTime, selectedAddressOption = _a.selectedAddressOption, options = _a.options;
    if (dispatchType === 'dine-in') {
        return 0;
    }
    if (selectedAddressOption && dispatchType === 'delivery') {
        var inBounds = getAllInBounds({
            totalOrderPrice: totalOrderPrice,
            dispatchTime: dispatchTime,
            address: selectedAddressOption,
            restaurant: restaurant,
            options: options,
        });
        // Now, get the best (=cheapest) available delivery area, if exists.
        var idealDeliveryArea = _(inBounds)
            .filter(function (v) { return v.reasons.length === 0; })
            .sortBy(function (v) { return v.info.charge || 0; })
            .first();
        if (!idealDeliveryArea) {
            idealDeliveryArea = _(inBounds)
                .filter(function (v) {
                return v.reasons.length === 1 && v.reasons[0].type === 'minimum-price';
            })
                .sortBy(function (v) { return v.info.minOrderPrice || 0; })
                .first();
        }
        return ((_b = idealDeliveryArea === null || idealDeliveryArea === void 0 ? void 0 : idealDeliveryArea.info) === null || _b === void 0 ? void 0 : _b.minOrderPrice) || 0;
    }
    else {
        return ((dispatchType === 'delivery'
            ? getMinimalOrderPriceForAllAreas(restaurant.deliveryInfos, restaurant.timezone)
            : getMinimalPickupOrderPrice(restaurant.deliveryInfos)) || 0);
    }
}
export function getMinOrderPriceDetails(_a) {
    var totalOrderPrice = _a.totalOrderPrice, restaurant = _a.restaurant, dispatchType = _a.dispatchType, dispatchTime = _a.dispatchTime, selectedAddressOption = _a.selectedAddressOption, options = _a.options;
    var minOrderPrice = getMinOrderPrice({
        totalOrderPrice: totalOrderPrice,
        restaurant: restaurant,
        dispatchType: dispatchType,
        dispatchTime: dispatchTime,
        selectedAddressOption: selectedAddressOption,
        options: options,
    });
    var amountLeft = Math.max(minOrderPrice - totalOrderPrice, 0);
    var displayableMinOrderPrice = minOrderPrice
        ? getDisplayablePrice(minOrderPrice, restaurant.locale, restaurant.currency)
        : undefined;
    var displayableAmountLeft = amountLeft
        ? getDisplayablePrice(amountLeft, restaurant.locale, restaurant.currency)
        : undefined;
    return {
        minOrderPrice: minOrderPrice,
        displayableMinOrderPrice: displayableMinOrderPrice,
        amountLeft: amountLeft,
        displayableAmountLeft: displayableAmountLeft,
    };
}
//# sourceMappingURL=dispatchTypeLogic.js.map